import React from 'react'
import { createStyles, withStyles, Button, useTranslation } from '@paintscout/ui'
import type { WithStyles } from '@paintscout/ui'

const styles = createStyles({
  root: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'white'
  }
})

export interface RetryOverlayProps extends WithStyles<typeof styles> {
  onRetry?: () => any
}

function RetryOverlay(props: RetryOverlayProps) {
  const { __ } = useTranslation()
  return (
    <div className={props.classes.root}>
      <Button variant="outlined" onClick={props.onRetry}>
        {__('Retry')}
      </Button>
    </div>
  )
}

export default withStyles(styles)(RetryOverlay)
